import PageContainer from '@/views/base/page.vue'
export default [
  {
    path: '/index',
    component: PageContainer,
    children: [
      {
        path: '/course',
        component: () => import('@/views/course/index.vue'),
        meta: { title: '课程', keepAlive: true, needAuth: false }
      },
      {
        path: '/course/detail',
        component: () => import('@/views/course/components/model/common-details.vue'),
        meta: { title: '课程详情', keepAlive: false, needAuth: false }
      }
    ]
  }
]
